import React from "react";

const SavedCounter = React.createContext({});

export { SavedCounter };
